import InputLoader from './InputLoader';

export default InputLoader;
